export const GET_USER = 'GET_USER';
export const GET_USERS = 'GET_USERS';
export const ACTION_REQUEST = 'ACTION_REQUEST';
export const ACTION_REQUEST_END = 'ACTION_REQUEST_END';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';
export const AUTH_RESET = 'AUTH_RESET';
export const REGISTER_COMPLETE = 'REGISTER_COMPLETE';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const GOOGLE_SIGNUP_SUCCESS = 'GOOGLE_SIGNUP_SUCCESS';
export const GOOGLE_SIGNUP_FAIL = 'GOOGLE_SIGNUP_FAIL';
export const ACCOUNT_RECOVER = 'ACCOUNT_RECOVER';
export const ACCOUNT_RECOVER_FAIL = 'ACCOUNT_RECOVER_FAIL';
export const UPDATE_USER = 'UPDATE_USER';
export const GET_MEMOIRS = 'GET_MEMOIRS';
export const GET_FEEDBACKS = 'GET_FEEDBACKS';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_CUSTOMER_SUPPORT = 'GET_CUSTOMER_SUPPORT';
export const GET_ORDER_QRCODES = 'GET_ORDER_QRCODES';
export const GET_FUTURE_MESSAGES = 'GET_FUTURE_MESSAGES';
export const GET_SEARCHES = 'GET_SEARCHES';
export const GET_PAYMENTS = 'GET_PAYMENTS';
export const GET_COLLABORATIVES = 'GET_COLLABORATIVES';
export const GET_COLLABORATIVES_REQUESTS = 'GET_COLLABORATIVES_REQUESTS';
export const TOGGLE_THEME = 'TOGGLE_THEME';
export const PHONE_LOGIN = 'PHONE_LOGIN';
export const PHONE_SIGNUP_FAIL = 'PHONE_SIGNUP_FAIL';
export const PHONE_VERIFIED = 'PHONE_VERIFIED';
export const PHONE_VERIFIED_END = 'PHONE_VERIFIED_END';
export const GET_PACKAGES = 'GET_PACKAGES';
export const NAME_UPDATE_SUCCESS = 'NAME_UPDATE_SUCCESS';
export const NAME_UPDATE_FAIL = 'NAME_UPDATE_FAIL';
export const PHONE_UPDATE_SUCCESS = 'PHONE_UPDATE_SUCCESS';
export const PHONE_UPDATE_END = 'PHONE_UPDATE_END';
export const PHONE_UPDATE_FAIL = 'PHONE_UPDATE_FAIL';
export const EMAIL_UPDATE_SUCCESS = 'EMAIL_UPDATE_SUCCESS';
export const EMAIL_UPDATE_FAIL = 'EMAIL_UPDATE_FAIL';
export const ADDRESS_UPDATE_SUCCESS = 'ADDRESS_UPDATE_SUCCESS';
export const ADDRESS_UPDATE_FAIL = 'ADDRESS_UPDATE_FAIL';
export const SUBSCRIPTION_CANCEL_SUCCESS = 'SUBSCRIPTION_CANCEL_SUCCESS';
export const SUBSCRIPTION_CANCEL_FAIL = 'SUBSCRIPTION_CANCEL_FAIL';
export const SUBSCRIPTION_CHANGE_SUCCESS = 'SUBSCRIPTION_CHANGE_SUCCESS';
export const SUBSCRIPTION_CHANGE_FAIL = 'SUBSCRIPTION_CHANGE_FAIL';
export const GOOGLE_FULL_SIGNUP_SUCCESS = 'GOOGLE_FULL_SIGNUP_SUCCESS';
export const GOOGLE_FULL_SIGNUP_FAIL = 'GOOGLE_FULL_SIGNUP_FAIL';
export const GOOGLE_LOGIN_SUCCESS = 'GOOGLE_LOGIN_SUCCESS';
export const GOOGLE_LOGIN_FAIL = 'GOOGLE_LOGIN_FAIL';
export const CREATE_MEMOIR = 'CREATE_MEMOIR';
export const CREATE_MEMOIR_FAIL = 'CREATE_MEMOIR_FAIL';
export const ADD_TIMLINE = 'ADD_TIMLINE';
export const ADD_TIMLINE_FAIL = 'ADD_TIMLINE_FAIL';
export const UPDATE_MEMOIR_STATUS = 'UPDATE_MEMOIR_STATUS';
export const UPDATE_MEMOIR_STATUS_FAIL = 'UPDATE_MEMOIR_STATUS_FAIL';
export const ORDER_LOADING = 'ORDER_LOADING';
export const SET_DELIVERY_LOADING = 'SET_DELIVERY_LOADING';
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const EMPTY_CART = 'EMPTY_CART';
export const SUB_QTY = 'SUB_QTY';
export const ADD_QTY = 'ADD_QTY';
export const GET_BLOGS = 'GET_BLOGS';
export const GET_SINGLE_BLOG = 'GET_SINGLE_BLOG';
export const GET_SHIPPERS = 'GET_SHIPPERS';
export const CUSTOM_ALERT = 'CUSTOM_ALERT';
